import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import ProjectCreateDrawer from './ProjectCreateDrawer';
import { useEffect, useState } from 'react';
import {
  deleteProjectAsync,
  getProjectListAsync,
  setCurrentProjectId,
} from '../../modules/projects';
import { Alert, Spin } from 'antd';
import ProjectListComponent from '../../components/projects/ProjectListComponent';
import { useHistory } from 'react-router-dom';

interface ProjectListContainerProps {
  enterpriseId: string;
}

function ProjectListContainer({ enterpriseId }: ProjectListContainerProps) {
  const history = useHistory();
  const { data, loading, error } = useSelector(
    (state: RootState) => state.projects.projects,
  );
  const [visibleCreateDrawer, setVisibleCreateDrawer] =
    useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProjectListAsync.request({ enterpriseId }));
  }, [dispatch, enterpriseId]);

  const onDeleteProject = (_projectId: number) => {
    dispatch(
      deleteProjectAsync.request({ enterpriseId, projectId: '' + _projectId }),
    );
  };

  const moveToProjectCreatePage = () => {
    // history.push(`/enterprises/${enterpriseId}/create-project`);
    setVisibleCreateDrawer(true);
  };

  const moveToDetailPage = (projectId: number) => {
    dispatch(setCurrentProjectId(projectId));
    history.push(
      `/enterprises/${enterpriseId}/projects/${projectId}/dashboard`,
    );
  };

  const onSearch = (values: any) => {
    const filter: any = {};
    if ('name' in values && values.name !== undefined && values.name !== '')
      filter.name = values.name;
    if (
      'status' in values &&
      values.status !== undefined &&
      values.status !== ''
    )
      filter.status = values.status;
    if ('owner' in values && values.owner !== undefined && values.owner !== '')
      filter.owner = values.owner;
    dispatch(getProjectListAsync.request({ enterpriseId, filter }));
  };

  return (
    <>
      {loading && <Spin />}
      {/* {error && (
        <p style={{ textAlign: 'center' }}>
          접근 권한이 없습니다. 관리자에게 문의 바랍니다.
        </p>
      )} */}
      {/* {error && (
        <Modal visible={!!error}>
          <p>{error.response?.data.message}</p>
        </Modal>
      )} */}

      {error && (
        <Alert
          message={`${error.response?.data.message}`}
          type="error"
          showIcon
          closable
        />
      )}

      {data && (
        <ProjectListComponent
          moveToCreatePage={moveToProjectCreatePage}
          onDelete={onDeleteProject}
          moveToDetailPage={moveToDetailPage}
          onSearch={onSearch}
          data={data}
        />
      )}

      <ProjectCreateDrawer
        enterpriseId={enterpriseId}
        visibleDrawer={visibleCreateDrawer}
        onClose={() => setVisibleCreateDrawer(false)}
      />
    </>
  );
}

export default ProjectListContainer;
